export const APPROVAL_CHAIN_TEMPLATE_MODEL = "approval-chain-template";

const approvalChainTemplateModel = {
  organisationUnitId: "",
  currencyCode: "GBP",
  totalCostLower: 0,
  totalCostUpper: 0,
  user_id: "",
  approvers: [],
  client: {
    jsonApi: "hasOne",
    type: "organisations"
  },
  user: {
    jsonApi: "hasOne",
    type: "users"
  },
  approvalChainTemplateLevels: {
    jsonApi: "hasMany",
    type: "approval-chain-template-levels"
  }
};

export default approvalChainTemplateModel;
